import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function LegalStep() {
  const translate = useTranslate();

  return (
    <Form.Editor
      name="legal_text"
      label={translate("flux.fields.legal_text")}
      minHeight={300}
    />
  )
}
